module.exports = __webpack_public_path__ + "components/flag/static/square/om-38894b770b816d68b1d0fa73ccfca976.svg";